import { API_BASE_URL as API_BASE } from '../config/api';
import { getToken, setToken } from './authApi';
import { saveTenantPayRoomCode } from '../utils/tenantPayRoom';

export type TenantQrVerifyResult = {
  access_token: string;
  token_type: string;
  account_type: string;
  user_id: number;
  pay_room_code: string;
  message?: string;
};

export type TenantQrSessionStatus = {
  valid: boolean;
  reason?: string;
  message?: string;
  pay_room_code?: string;
  room_label?: string;
  phone_masked?: string;
};

async function readError(res: Response, fallback: string): Promise<string> {
  try {
    const data = await res.json();
    if (typeof data?.detail === 'string') return data.detail;
    if (Array.isArray(data?.detail) && data.detail[0]?.msg) return data.detail[0].msg;
    if (typeof data?.message === 'string') return data.message;
  } catch {
    // ignore
  }
  return fallback;
}

export async function loginTenantByCccd(cccd: string): Promise<TenantQrVerifyResult> {
  const res = await fetch(`${API_BASE}/auth/tenant-qr/login-cccd`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cccd }),
  });
  if (!res.ok) throw new Error(await readError(res, 'Không tìm thấy hợp đồng với số căn cước này'));
  const data = (await res.json()) as TenantQrVerifyResult;
  if (!data.access_token) throw new Error('Không nhận được phiên đăng nhập');
  setToken(data.access_token);
  saveTenantPayRoomCode(String(data.user_id), data.pay_room_code);
  return data;
}

export async function checkTenantQrSession(): Promise<TenantQrSessionStatus> {
  const token = getToken();
  if (!token) {
    return {
      valid: false,
      reason: 'no_token',
      message: 'Phiên đăng nhập đã hết hạn. Vui lòng nhập số căn cước công dân lại.',
    };
  }

  const res = await fetch(`${API_BASE}/auth/tenant-qr/session-status`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 401) {
    return {
      valid: false,
      reason: 'unauthorized',
      message: 'Phiên đăng nhập đã hết hạn. Vui lòng nhập số căn cước công dân lại.',
    };
  }

  if (!res.ok) {
    throw new Error(await readError(res, 'Không kiểm tra được phiên đăng nhập'));
  }

  return res.json() as Promise<TenantQrSessionStatus>;
}
